import { SimService } from './../../../sims/services/sim.service';
import { Permiso } from './../../../../_entities/Enums/permiso.enum';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DispositivoVM } from './../../../../_entities/dispositivos/DispositivoVM';
import { DispositivoService } from './../../services/dispositivo.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';


@Component({
	selector: 'kt-dispositivo',
	templateUrl: './dispositivo.component.html',
	styleUrls: ['./dispositivo.component.scss']
})
export class DispositivoComponent implements OnInit {
	public dispositivosRegistros: DispositivoVM[];
	public datosReporte = [];

	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public showNavigationButtons: boolean;
	public showPageSizeSelector: boolean;
	public seElimina: boolean = true;
	public isDisabled: boolean = true;
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna";

	public permisoConsultarDispositivos: string;
	public permisoAgregarDispositivo: string;
	public permisoActualizarDispositivo: string;
	public permisoEliminarDispositivo: string;

	constructor(private dispositivoService: DispositivoService,
		private simService: SimService,
		private toastService: ToastrService,
		private router: Router) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.showNavigationButtons = true;
		this.showPageSizeSelector = true;
	}

	ngOnInit() {
		this.obtenerPermisos();
		this.obtenerDispositivos();
	}

	/**Obtienes todos los dispositivos */
	obtenerDispositivos() {
		this.dispositivoService.obtenerDispositivos().subscribe(
			(response: DispositivoVM[]) => {
				this.dispositivosRegistros = response.map(x => {
					let imei = '';
					let sim = ''
					if (x.imei) {
						imei = x.imei.toString()
					}

					if (x.sim) {
						sim = x.sim.toString()
					}

					this.datosReporte.push(
						{
							'IMEI': imei,
							'Teléfono': x.numeroTelefonico,
							'Número de Serie': x.numeroSerie,
							'Marca': x.marca,
							'Modelo': x.modelo,
							'Sim': sim,
							'Estatus': this.obtenerEstatus(x.estatus)
						}
					)

					return {
						imei: x.imei,
						numeroSerie: x.numeroSerie,
						modelo: x.modelo,
						marca: x.marca,
						sim: x.sim,
						estatus: this.obtenerEstatus(x.estatus),
						idCliente: x.idCliente,
						numeroTelefonico: x.numeroTelefonico
					}
				});

				if (this.datosReporte.length > 0) {
					this.isDisabled = false
				}
			}, (error) => {
				this.toastService.error('Ocurrio un error al intentar obtener los dispositivos gps', '');
			}
		)
	}

	/**Alta dispositivo */
	altaDispositivo() {
		this.router.navigateByUrl('/home/administracion/dispositivos/dispositivo/alta');
	}

	/**Editar dispositivo*/
	editarDispositivo(imei) {
		this.router.navigateByUrl('/home/administracion/dispositivos/dispositivo/editar/' + imei);
	}

	/**Valida el estatus */
	obtenerEstatus(estatus) {
		let estado = '';
		switch (estatus) {
			case 0:
				estado = 'Baja';
				break;
			case 1:
				estado = 'Disponible';
				break;
			case 2:
				estado = 'Asignado';
				break;
			case 3:
				estado = 'Revisión';
				break;
		}
		return estado;
	}

	/**
   * Se realiza el consumo de servicios de eliminación
   * Modificado:Luis Enrique
   * @param dispositivo
   */
	eliminarDispositivo(dispositivo) {
		if (dispositivo.sim === null) {
			Swal.fire({
				title: 'Eliminar',
				text: `¿Está seguro que desea eliminar el dispositivo ` + dispositivo.imei + ' ?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirmar',
				cancelButtonText: "Cancelar"
			}).then((result) => {
				if (result.value) {
					this.dispositivoService.eliminarSinSim(dispositivo.imei).subscribe(res => {
						this.toastService.success("Dispositivo Eliminado")
						this.obtenerDispositivos();
					}, err => {
						this.toastService.error(err.error)
					});
				}
			})
		} else if (dispositivo.sim != '' || dispositivo.sim != null) {
			Swal.fire({
				title: 'Eliminar',
				text: `¿Está seguro que desea eliminar el dispositivo ` + dispositivo.imei + ' ?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirmar',
				cancelButtonText: "Cancelar"
			}).then((result) => {
				if (result.value) {
					Swal.fire({
						title: 'Eliminar',
						text: '¿Deseas dejar disponible el SIM?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Si',
						cancelButtonText: "No"
					}).then((result) => {
						if (result.value === true) {
							this.dispositivoService.eliminarSim(dispositivo.imei, this.seElimina).subscribe(result => {
								this.obtenerDispositivos();
								this.toastService.success("Dispositivo Eliminado")
							})
						} else {
							this.seElimina = false;
							this.dispositivoService.eliminarNoSim(dispositivo.imei, this.seElimina).subscribe(result => {
								this.obtenerDispositivos();
								this.toastService.success("Dispositivo Eliminado")
							})

						}
						this.obtenerDispositivos();
					})
				}
			})
		}
	}

	/**Obtener permisos para dispositivos */
	public get Permiso() {
		return Permiso;
	}

	cambiarEstatus(imei, estatus) {
		/**
		 * 0 = baja
		 * 1 = disponible
		 * 2 = asignado
		 * 3 = revision
		 */

		this.dispositivoService.cambiarEstatus(imei, estatus).subscribe(
			(response) => {
				this.obtenerDispositivos();
				this.toastService.success('Estatus actualizado');
			}, (error) => {
				this.toastService.error('Error al actualizar estatus');
			}
		)

	}

	obtenerPermisos() {
		this.permisoConsultarDispositivos = Permiso.ConsultarDispositivos;
		this.permisoAgregarDispositivo = Permiso.AgregarDispositivo;
		this.permisoActualizarDispositivo = Permiso.ActualizarDispositivo;
		this.permisoEliminarDispositivo = Permiso.EliminarDispositivo;
	}

}
